import { useLocation, matchPath } from 'react-router-dom';
import { PASSPORT_PATH_LIST } from '../config/routes/paths';
import { normalizeRoutePath } from '../lib/helpers/urlHelper';

export default function useCurrentRoutePath(pathPrefix = ''): string | void {
  const { pathname } = useLocation();

  return PASSPORT_PATH_LIST
    .map(path => normalizeRoutePath(path, pathPrefix))
    .find(path => Boolean(matchPath(pathname, { path })));
}
